export default "__VITE_ASSET__C1b4numC__"